import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { AuthContext } from "@/contexts/auth-context";
import { cn } from "@/lib/utils";

import logo from "@/assets/logo.svg";

const HeaderBar = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  if (!user) {
    return null;
  }

  return (
    <div
      className={cn(
        "fixed top-0 left-0 right-0 w-full bg-white z-20 py-[8px] px-[24px] flex gap-2 border-b border-grey-200 flex-shrink-0",
        "sm:px-8"
      )}
      style={{ height: "52px" }}
    >
      <img
        width={"auto"}
        height={"32px"}
        src={logo}
        alt={"Logo MyPerioApp"}
        onClick={() => navigate("/")}
        className="cursor-pointer"
      />
      <div className="w-full flex items-center justify-end">
        <Button
          onClick={() => navigate("/profile")}
          variant={"ghost"}
          className="rounded-full bg-[#E2E8F0] w-10 h-10"
        >
          {`${user.firstName[0]?.toUpperCase()}${user.lastName[0]?.toUpperCase()}`}
        </Button>
      </div>
    </div>
  );
};

export default HeaderBar;
